<script>
import Vue from 'vue'
import axios from 'axios'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import DatePicker from 'vue2-datepicker'
import { required } from 'vuelidate/lib/validators'


/**
 Crear Complemento de Pago
 */
export default {
  components: { Layout, PageHeader ,DatePicker},
  page: {
    title: 'Recibo Electrónico de Pago',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  data() {
    return {
      title: 'Recibo Electrónico de Pago',
      form: {
        uuid: '',
        idPago: '',
        razonSocial: '',
        rfc: '',
        fecha: '',
        total: '',
        fechaPago: '',
        formaPago: '',
        uuidRelacionado: '',        
      },
      items: [
        {
          text: 'Sistema Tributario',
          href: '/',
        },
        {
          text: 'Recibo Electrónico de Pago',
          href: '/complemento/',
        },
        {
          text: 'Crear',
          active: true,
        },
      ],
      submitted: false,
      isBusy: false,
    }
  },
  validations: {
    form: {
        formaPago:{
            required
        }     
    },
  },
  computed: {},
  mounted() {  
    this.loadPago(this.$route.params.id)
  },
  methods: {
    loadPago(id){
       axios
            .get(appConfig.recursosApi.pago + "/detallePago/" + id )
            .then((response) => {
                var pago = response.data;
                this.form.uuid = pago.uuid;
                this.form.razonSocial = pago.nombre;
                this.form.fecha = pago.fecha;
                this.form.total = pago.importe;  
                this.form.rfc = pago.rfc;   
                this.form.formaPago = "03"; 
                this.form.idPago = pago.idPago;          
            })
             .catch(()=>  {
               // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
                this.$router.push('/500') ;
            });

    },    
    _validations() {
      return new Promise((resolve) => {
        if (this.$v.$error || !this.$v.$pending) {
          return resolve()
        }
        let poll = setInterval(() => {
          if (!this.$v.$pending) {
            clearInterval(poll)
            resolve()
          }
        }, 200)
      })
    },

    async isValid() {
      this.$v.$reset()
      this.$v.$touch()
      await this._validations()
      return Promise.resolve(!this.$v.$error)
    },

    async handleSubmit(e) {
      this.submitted = true
      const valid = await this.isValid()
      this.isBusy = false

      if (valid) {
        this.isBusy = true        
        axios
          .post(appConfig.recursosApi.pago +"/complemento", this.form)
          .then((response) => {
            this.isBusy = false
            this.$router.push('/complemento')
          })
          .catch((err) => {
            var errDetalle = "";
            if (err.response) {                
                errDetalle= err.response.data;
            }
            
            this.isBusy = false
            Vue.swal({
              type: 'error',
              title: 'Ocurrio un error.',
              text:  errDetalle,
              confirmButtonClass: 'btn btn-confirm mt-2',
            })
          })
      }
    },
  },
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-6">
        <div class="card-box">
          <h4 class="header-title m-t-0">Generar REP</h4>
          <p class="text-muted font-14 m-b-20"
            >Ingresa la información del  Pago.</p
          >

          <form @submit.prevent="handleSubmit">
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="name">
                  Folio Fiscal
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="uuid"
                  v-model="form.uuid"
                  name="uuid"
                  class="form-control"
                  disabled
                  type="text"
                  placeholder=""
                />                
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-5">
                <label for="name">
                  RFC
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="rfc"
                  v-model="form.rfc"
                  name="rfc"
                  class="form-control"
                  disabled                  
                  type="text"
                  placeholder=""
                />                
              </div>
              <div class="form-group col-md-5">
                <label for="name">
                  Importe
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="importe"
                  v-model="form.total"
                  name="importe"
                  class="form-control"
                  disabled                  
                  type="text"
                  placeholder=""
                />                
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="name">
                  Razon Social
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="razonSocial"
                  v-model="form.razonSocial"
                  name="razonSocial"
                  class="form-control"
                  disabled
                  type="text"
                  placeholder=""
                />                
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="name">
                  Forma Pago
                  <span class="text-danger">*</span>
                </label>
                <select
                  v-model="form.formaPago"
                  type="number"
                  name="formaPago"
                  class="custom-select"
                  :class="{
                    'is-invalid': submitted && $v.form.formaPago.$error,
                  }"
                >
                  <option value="01">EFECTIVO</option>
                  <option value="04">TARJETA CREDITO</option>
                  <option value="28">TARJETA DEBITO</option>
                  <option value="03">TRANSFERENCIA</option>
                  <option value="02">CHEQUE</option>
                  <option value="99">POR DEFINIR</option>
                </select> 

              </div>
              <div class="form-group col-md-6">
                 <label for="name">
                      Fecha Pago
                    </label>
                <date-picker  
                        v-model="form.fechaPago"
                        :first-day-of-week="1" 
                        format="DD/MM/YYYY"                        
                        lang="es"></date-picker>
              </div> 
            </div>
           
            <div class="form-group text-right m-b-0">
              <button class="btn btn-primary" type="submit" :disabled="isBusy">
                <b-spinner v-show="isBusy" small></b-spinner> Generar</button
              >
              <router-link
                class="btn btn-secondary m-l-5 ml-1"
                to="/facturacion"
              >
                Cancelar</router-link
              >
            </div>
          </form>
        </div>
        <!-- end card-box -->
      </div>
    </div>
  </Layout>
</template>